export const blue = "#003366"
export const gold = "#FFBE00"
export const black = "#02030B"

export const mq = {
  small: "420px",
  medium: "720px",
  large: "1140px",
}
